import { createFileRoute } from '@tanstack/react-router';
import { UnderConstruction } from '@/shared/components/UnderConstruction';

export const Route = createFileRoute('/_backoffice/superadmin/')({
    component: () => (
        <UnderConstruction title="Home" hint="Consola de plataforma — próximamente." />
    ),
});
